import { render, staticRenderFns } from "./settingsMobileComp.vue?vue&type=template&id=77b0ff8f&scoped=true&"
import script from "./settingsMobileComp.vue?vue&type=script&lang=js&"
export * from "./settingsMobileComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b0ff8f",
  null
  
)

export default component.exports